function cookieRegions () {
    if (getCookie('region') === undefined || getCookie('region-text') === undefined) {
        setCookie('region', '45678', 90);
        setCookie('region-text', 'Екатеринбург', 90);
    }

    const regions = document.querySelectorAll('[data-region]');
    const regionTitle = document.querySelector('.region__link');
    const swapRegion = document.querySelector('.swap-region');

    for (let region of regions) {
        region.addEventListener('click', function (e) {
            e.preventDefault();
            const dataRegion = region.getAttribute('data-region');
            const textRegion = region.textContent;
            setCookie('region', dataRegion, 90);
            setCookie('region-text', textRegion, 90);
            regionTitle.textContent = getCookie('region-text');
            swapRegion.textContent = getCookie('region-text');
            $.fancybox.open({
                src: '#region-hidden',
                type: 'inline',
                afterClose  : function() {
                    window.location.href = '/#search';
                }
            });

        });
    };

    if(!getCookie('region-text') === undefined || getCookie('region-text') !== 'Екатеринбург') {
        regionTitle.textContent = getCookie('region-text');
    }
}

cookieRegions ();